import { render, staticRenderFns } from "./sendCompany.vue?vue&type=template&id=34e63dad&scoped=true"
import script from "./sendCompany.vue?vue&type=script&lang=js"
export * from "./sendCompany.vue?vue&type=script&lang=js"
import style0 from "./sendCompany.vue?vue&type=style&index=0&id=34e63dad&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e63dad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34e63dad')) {
      api.createRecord('34e63dad', component.options)
    } else {
      api.reload('34e63dad', component.options)
    }
    module.hot.accept("./sendCompany.vue?vue&type=template&id=34e63dad&scoped=true", function () {
      api.rerender('34e63dad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/lists/sendCompany.vue"
export default component.exports